const DOCUMENT_READY_STATE_COMPLETE = 'complete';

export default DOCUMENT_READY_STATE_COMPLETE;
